import { useMemo } from 'react';

import type { CustomCondition } from '~/api/conditions/types';

import { useCustomConditions } from '~/api/conditions';
import { AlertDialog, useTable } from '~/components';
import { ColumnIds } from '~/constants/table';

import { ConfirmDeleteCustomConditionDialog } from './ConfirmDeleteCustomConditionDialog';
import { useCustomConditionsTableColumns } from './CustomConditionsTable.hooks';

export const CustomConditionsTable = () => {
  const { data: customConditions } = useCustomConditions();

  const deleteCustomConditionHandle = AlertDialog.useHandle<CustomCondition>();
  const dialogHandles = useMemo(() => ({ deleteCustomConditionHandle }), [deleteCustomConditionHandle]);

  const columns = useCustomConditionsTableColumns({ dialogHandles });

  const [table, Table] = useTable({
    data: customConditions,
    columns,
    initialState: {
      sorting: [
        {
          id: ColumnIds.customConditionsName,
          desc: false,
        },
      ],
    },
    enableSortingRemoval: false,
  });

  return (
    <>
      <Table.Root table={table}>
        <Table.Menu>
          <Table.Search />
        </Table.Menu>

        <Table.Grid>
          <Table.Header />
          <Table.Body>{(row) => <Table.Row row={row} />}</Table.Body>
        </Table.Grid>

        <Table.Pagination />
      </Table.Root>

      <AlertDialog.Root handle={deleteCustomConditionHandle}>
        {({ payload: customCondition }) =>
          customCondition && (
            <ConfirmDeleteCustomConditionDialog customCondition={customCondition} onClose={() => deleteCustomConditionHandle.close()} />
          )
        }
      </AlertDialog.Root>
    </>
  );
};
